export const MISSING_DECLARATIONS = "MISSING_DECLARATIONS";

export const HIDE_DCLRTN_INFO_FOR_EMP_VIEW_YEAR = "2025";
